module.exports = __webpack_public_path__ + "assets/img/077560b454a0b5416fff379bdb8a93f0.svg";